/** Minutos después del fin nominal del turno para mostrar aviso de salida tardía. */
export const EXIT_DELAY_WARN_MINUTES = 30;

function parseHhmm(str) {
  const m = String(str || '')
    .trim()
    .match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return null;
  return { h: Number(m[1]), min: Number(m[2]) };
}

/** Fin de turno en el calendario local del tablero (ms). Turno noche: fin al día siguiente. */
function shiftEndLocalMs(boardDateYmd, shiftStartStr, shiftEndStr) {
  const ts = parseHhmm(shiftStartStr);
  const te = parseHhmm(shiftEndStr);
  if (!ts || !te || !boardDateYmd) return null;
  const overnight = te.h < ts.h || (te.h === ts.h && te.min <= ts.min);
  const [Y, Mo, D] = boardDateYmd.split('-').map(Number);
  return new Date(Y, Mo - 1, D + (overnight ? 1 : 0), te.h, te.min, 0, 0).getTime();
}

/**
 * Minutos entre check-out y fin nominal del turno (positivo = salió después del fin).
 * null si no se puede calcular o turno nocturno (evita falsos positivos sin revisar bien).
 */
export function getExitDelayMinutesAfterShiftEnd(row, boardDateYmd) {
  if (!row?.check_out_time || !boardDateYmd || !row.shift_end || !row.shift_start) return null;
  const ts = parseHhmm(row.shift_start);
  const te = parseHhmm(row.shift_end);
  if (!ts || !te) return null;
  const overnight = te.h < ts.h || (te.h === ts.h && te.min <= ts.min);
  if (overnight) return null;
  const endMs = shiftEndLocalMs(boardDateYmd, row.shift_start, row.shift_end);
  if (endMs == null) return null;
  const outMs = new Date(row.check_out_time).getTime();
  return Math.floor((outMs - endMs) / 60000);
}
